import { api, helpers, ts } from '_core';

type UniverseApiResponse = {
  data: ts.types.universe.Universe;
};

export const createUniverse = async (
  newData: ts.types.universe.UniverseDraft,
  callback: (_data: ts.types.universe.Universe) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: UniverseApiResponse = await api.universes.create(newData);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error creating universe - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateUniverse = async (
  id: number,
  newData: ts.types.universe.UniverseDraft,
  callback: (_data: ts.types.universe.Universe) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: UniverseApiResponse = await api.universes.update(id, { ...newData });
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating universe - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDefinition = async (
  id: number,
  definition: ts.types.universe.DefinitionDraft,
  isValid: boolean,
  callback: (_data: ts.types.universe.Universe) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const def = { ...definition };
    if (def?.assets?.length <= 1) def.assets = [];

    if (def.source?.type == 'universes') delete def.quotation_countries;

    const updateData = {
      definition,
      is_valid: isValid,
      skip_signature_check: !isValid,
    } as ts.types.universe.UniverseDraft;

    if (def.source?.type == 'etf' || def.source?.type == 'index' || def.source?.type == 'assets')
      updateData.frequency = ts.enums.FREQUENCY_ENUM.DAILY;

    const resp = await api.universes.update(id, updateData, true);
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the definition - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};
